import React, { FC } from 'react';
import Content from './Content';

export interface PreferencesTileProps { }

const PreferencesTile: FC<PreferencesTileProps> = () => (
  <Content />
);

export default PreferencesTile;
